import { SVGProps } from 'react';

export const SvgPromotions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M9.66664 14C9.5791 14.3174 9.4299 14.6144 9.22756 14.8741C9.02523 15.1338 8.77373 15.3511 8.48741 15.5136C8.2011 15.6761 7.88558 15.7806 7.55888 15.8212C7.23217 15.8617 6.90067 15.8376 6.58331 15.75C6.26595 15.6625 5.96894 15.5133 5.70924 15.3109C5.44954 15.1086 5.23223 14.8571 5.06973 14.5708C4.90723 14.2845 4.80271 13.9689 4.76215 13.6422C4.72158 13.3155 4.74576 12.984 4.83331 12.6667M2.5 9.16667L17.5 5V15L2.5 11.6667V9.16667Z"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
